import { configureStore } from '@reduxjs/toolkit';
import userStateReducer from './userState';
import deviceStateReducer from './deviceState';
import trackingStateReducer from './trackingState';

//**********************************************************

export const store = configureStore
({
    reducer:
        {
            userState: userStateReducer,
            deviceState: deviceStateReducer,
            trackingState: trackingStateReducer,
        }
});

export type AppStore = typeof store;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];
